export default __webpack_public_path__ + "static/media/cladding24.323d25bf.jpg";